// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/style/less/app.less
 ** module id = 6
 ** module chunks = 0
 **/